export enum Currency {
  euro = '€',
  dollar = '$',
  pound = '£',
}

export type CurrencyCode = 'EUR' | 'USD' | 'GBP';
